import React, { useEffect, useState } from "react";
import "./home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Emitter from "../../utils/emitter";
import * as queries from "../../utils/prismicQueries";
import client from "../../utils/prismicHelpers";
import video from '../../assets/video/video.mp4'
import ReactPlayer from "react-player";

const HomeSection = ({ sectionNo }) => {
  const [reRender, setRerender] = useState(false)
  const [homeDoc, setHomeDoc] = useState(null);
  const [newsletter, setNewsletter] = useState(true);
  useEffect(() => {
    client
      .query({
        query: queries.heroSection,
      })
      .then((response) => {
        const homeDocContent = response.data.allHomes.edges[0].node;
        setHomeDoc(homeDocContent);
      })
      .catch((error) => {
        console.error(error);
      });
    setTimeout(() => {
      setRerender(true)
    }, 4000);    // Emitter.on("TOGGLE_MENU", (newValue) => setToggle(!toggled));
  });
  function moveDown() {
    Emitter.emit("MOVE_DOWN", "DOWN");
  }
  const submitNewsletter = () => {
    const data = [
      {
        "id": "0",
        "title": "My Item number 0",
        "description": "Lorem ipsum",
        "image_url": "https://if-test-custom-api.herokuapp.com/asset/0",
        "last_update": 1591670070,
        "blob": { "Item": "new riyaddd.com" }
      }
    ]
    const newData = JSON.stringify(data)
    // console.log(JSON.stringify(data),"sringfied data");
    fetch("https://if-api.prismic.io/if/write/artparkwebsite--newsletter", {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJwcmlzbWljLmlvIiwiaWF0IjoxNjUzNTQyODQ3NDM2LCJjYXRhbG9nSWQiOiJhcnRwYXJrd2Vic2l0ZS0tbmV3c2xldHRlciJ9.lr0hEMm9K0m_AC94uU90DHjgsYXaHBODKnxQbtvbscU',
        'Content-Type': 'application/Json'
      },
      body: data

    })
      .then(response => response.json())
      .then(data => {
   
        // toast.dismiss(loading);
        // setResponseData(data.data);
        // if (!data.error) {

        //   return swal(`selectable Qsn added `, `selectable Qsn has been added successful.`, "success");
        // }
        // swal("Failed!", "Something went wrong! Please try again.", "error", { dangerMode: true });
      })
      .catch(error => {
        console.log(error);
        // toast.dismiss(loading);
        // swal("Failed!", "Something went wrong! Please try again.", "error", { dangerMode: true });
      })
  }

  return (
    <div style={{ backgroundImage: `url(${homeDoc?.image?.url})` }} className="container-fluid home-section">
      {/* <div className=" ">
    {sectionNo===0? 
            <video
            loop={true}
            muted={true}
            autoplay="true"
            preload="autoPlay"
            >
                <source src={!newsletter?video :video} type="video/mp4"/>
                Your video does not support  the video tag
            </video> : null}

            
        </div> */}
      <div className="container">
        <div className="d-flex justify-content-center align-content-center">

          <h1 className="heading-home">
            {homeDoc?.heading[0]?.text}
          </h1>

          {homeDoc?.showlearnmorebtn &&
            <a target="_blank" href={homeDoc?.btn_link}
              className=" heading-btn"
            >{homeDoc?.btn_text}
            </a>}

          {/* <p
            onClick={submitNewsletter}
            className=" heading-btn"
          >{homeDoc?.btn_text}
          </p> */}
        </div>
      </div>
 
      <div className="ScrollDown">
        <div className="text-center text-white">
          <FontAwesomeIcon
            icon={faChevronDown}
            className="down-icon"
            size="xs"
            onClick={() => moveDown()}
          />
        </div>
      </div>
    </div>
  );
};

export default HomeSection;
